<template>
    <div class="partner_addupdate">
        <div class="partner_addupdate_content">
            <div class="form_title"><img src="../assets/images/botImg9.png"/>资料信息</div>
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                <el-form-item label="合同编号" prop="contract_num">
                    <el-input v-model="ruleForm.contract_num" placeholder="请填写合作商合同编号"></el-input>
                </el-form-item>
                <el-form-item label="公司名称" prop="nickname">
                    <el-input v-model="ruleForm.nickname" placeholder="请保证与合同中合作商名称一致"></el-input>
                </el-form-item>
                <el-form-item label="合作商姓名" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请填写您的真实姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号码" prop="phone">
                    <el-input v-model="ruleForm.phone" placeholder="请填写手机号码"></el-input>
                </el-form-item>
                <el-form-item label="邮箱账号" prop="email">
                    <el-input v-model="ruleForm.email" placeholder="请填写邮箱"></el-input>
                </el-form-item>
                <el-form-item label="公司地址" prop="address">
                    <el-input v-model="ruleForm.address" placeholder="请填写公司地址" readonly
                              @click.native="toggleModal"></el-input>
                    <img src="../assets/images/rig_b2.svg" class="Address" @click="toggleModal">
                </el-form-item>
                <el-form-item label="作者昵称" prop="author">
                    <el-input v-model="ruleForm.author" placeholder="请填写作者昵称"></el-input>
                </el-form-item>
                <el-form-item label="合作版本" prop="group_id">
                    <el-select v-model="ruleForm.group_id" placeholder="请选择合作版本" class="min_select">
                        <el-option :value="item.id" :key="item.id" v-for="item in group_list" v-if="item.status == 1"
                                   :label="item.title"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="证件信息" prop="card_over">
                    <div class="papers">
                        <div class="papers_d1">
                            <el-upload class="papers_p3" action='' :show-file-list="false"
                                       :http-request="uploadSectionFile_card_1"
                                       :before-upload="beforeAvatarUpIDcard">
                                <img v-if="justimageUrl" :src="justimageUrl" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <el-upload class="papers_p3" action="" :show-file-list="false"
                                       :http-request="uploadSectionFile_card_2"
                                       :before-upload="beforeAvatarUpIDcard">
                                <img v-if="negativeimageUrl" :src="negativeimageUrl" class="avatar">
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </div>
                        <div class="papers_d2">
                            <p>请上传中华人民共和国居民身份证，无居民身份证的内地居民可提交《临时居民身份证》。</p>
                            <p>格式要求：支持<i>.jpg.jpeg.bmp.gif.png</i>格式照片，大小不超过<i>5M</i></p>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="合同资料" prop="Contractdata">
                    <div class="papers">
                        <div class="papers_d1">
                            <li v-if="ruleForm.Contractdata.length != 0" v-for="(item,i) in ruleForm.Contractdata"
                                :key="i">
                                <div class="papers_p3">
                                    <img :src="item"/>
                                    <div class="papers_del" @click="delContractdata(i)">删除</div>
                                </div>
                            </li>
                            <el-upload class="papers_p3" action="" :show-file-list="false"
                                       :http-request="ContractdatahandleAvatarSuccess"
                                       :before-upload="beforeAvatarUpload" multiple>
                                <img :src="Contractdata" class="avatar">
                            </el-upload>
                        </div>
                        <div class="papers_d2">
                            <p>此处提交合同材料，需要合同各页面照片</p>
                            <p>格式要求：支持<i>.jpg.jpeg.bmp.gif.png</i>格式照片，大小不超过<i>5M</i></p>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="营业执照">
                    <div class="papers">
                        <div class="papers_d1">
                            <li v-if="ruleForm.License.length != 0" v-for="(item,i) in ruleForm.License" :key="i">
                                <div class="papers_p3">
                                    <img :src="item"/>
                                    <div class="papers_del" @click="delLicense(i)">删除</div>
                                </div>
                            </li>
                            <el-upload class="papers_p3" action="" :show-file-list="false"
                                       :http-request="LicensehandleAvatarSuccess"
                                       :before-upload="beforeAvatarUpload" multiple>
                                <img :src="License" class="avatar">
                            </el-upload>
                        </div>
                        <div class="papers_d2">
                            <p>只支持中国大陆工商局或市场监督管理局颁发的工商营业执照，且必须在有效期内。</p>
                            <p>格式要求：原件照片，扫描或加盖公章的复印件，支持<i>.jpg.jpeg.bmp.gif.png</i>格式照片，大小不超过<i>5M</i>
                            </p>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="其他资料">
                    <div class="papers">
                        <div class="papers_d1">
                            <li v-if="ruleForm.Otherdata.length != 0" v-for="(item,i) in ruleForm.Otherdata" :key="i">
                                <div class="papers_p3">
                                    <img :src="item"/>
                                    <div class="papers_del" @click="delOtherdata(i)">删除</div>
                                </div>
                            </li>
                            <el-upload class="papers_p3" action="" :show-file-list="false"
                                       :http-request="OtherdatahandleAvatarSuccess"
                                       :before-upload="beforeAvatarUpload" multiple>
                                <img :src="Otherdata" class="avatar">
                            </el-upload>
                        </div>
                        <div class="papers_d2">
                            <p>此处提交其他证明材料</p>
                            <p>格式要求：支持<i>.jpg.jpeg.bmp.gif.png</i>格式照片，大小不超过<i>5M</i></p>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="合作级别" style='position: relative;' required>
                    <el-select v-model="rank" placeholder="请选择合作级别">
                        <el-option :value="1" label="全国终端商"></el-option>
                        <el-option :value="3" label="省级合作"></el-option>
                        <el-option :value="4" label="区域终端商"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="合作商地址" v-if="rank =='3'|| rank =='4'" required>
                    <div id="example">
                        <select v-model="prov">
                            <option v-for="option in arr" :value="option.name">
                                {{ option.name }}
                            </option>
                        </select>
                        <select v-model="city" v-if="rank =='4'">
                            <option v-for="option in cityArr" :value="option.name">
                                {{ option.name }}
                            </option>
                        </select>
                        <select v-model="district" v-if="district&&rank =='4'">
                            <option v-for="option in districtArr" :value="option.name">
                                {{ option.name }}
                            </option>
                        </select>
                    </div>
                </el-form-item>
                <div>
                    <el-form-item label="使用周期" prop="setdate" required>
                        <div class="date">
                            <div class="block">
                                <el-date-picker v-model="ruleForm.setdate" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                                type="daterange" range-separator="至" start-placeholder="开始日期"
                                                end-placeholder="结束日期"
                                                style="width:250px">
                                </el-date-picker>
                            </div>
                        </div>
                    </el-form-item>
                </div>
                <el-form-item label="终端数">
                    <div class="terminalsnum">
                        <el-input v-model="ruleForm.acc_num"></el-input>
                        <p>默认为0，<span class="">0为不限制</span></p>
                    </div>
                </el-form-item>
                <el-form-item label="自主版权" prop="copyright" required>
                    <el-radio-group v-model="ruleForm.copyright">
                        <el-radio :label='0'>关闭</el-radio>
                        <el-radio :label='1'>开启</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="素材版权" prop="resource" required>
                    <el-radio-group v-model="ruleForm.resource">
                        <el-radio :label='0'>允许使用</el-radio>
                        <el-radio :label='1'>不允许使用</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="多作品管理:" prop="MultipleWorks" required>
                    <el-radio-group v-model="ruleForm.MultipleWorks">
                        <el-radio :label='0'>关闭</el-radio>
                        <el-radio :label='1'>开启</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="多作品终端数:" v-if="ruleForm.MultipleWorks == 1" required>
                    <el-input v-model="ruleForm.Mulacc_num" maxlength="4"></el-input>
                    <span style="padding-left: 5px;">注：最大可创建9999个，0为不限制</span>
                </el-form-item>
                <el-form-item label="离线包下载:" prop="offline" required>
                    <el-radio-group v-model="ruleForm.offline">
                        <el-radio :label='0'>10元</el-radio>
                        <el-radio :label='1'>0.01元</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="备注信息">
                    <el-input class="beitxt" type="textarea" v-model="ruleForm.remark"></el-input>
                </el-form-item>
                <el-form-item label="验证码" required>
                    <div class="phone_code" prop="resource">
                        <el-input v-model="ruleForm.phone_code"></el-input>
                        <el-button type="primary" @click="takePhoneCode()" :disabled="canTakeCode">
                            <div v-if="!canTakeCode">获取验证码</div>
                            <div v-else>重新获取（{{ code_time }}秒）</div>
                        </el-button>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div class="submit">
                        <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
                        <el-button type="success" @click="resetPassword()">重置密码</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <Modal v-show="showModal" :show="showModal" ref="gaode_map" v-on:closeme="closeme"></Modal>
    </div>
</template>
<script>
import Modal from '../layout/gaode_map';
import {getArr} from '../assets/js/json.js'
import {getData, postData, qiniuPost, qiniuPostNew, OSSuploadPost} from "../assets/js/httpRequest";

export default {
    data() {
        var isData = (rule, value, callback) => {
            if (this.rank == '1' && this.ruleForm.setdate == null) {
                callback(new Error('请选择使用周期!'));
            } else {
                callback();
            }
            ;
        };

        var card_over = (rule, value, callback) => {
            if (this.ruleForm.negativeimageUrl == '' || this.ruleForm.justimageUrl == '') {
                callback(new Error(' '));
            } else {
                callback();
            }
            ;
        };

        var phone_over = (rule, value, callback) => {

            var reg01 =
                /^(0|86|17951)?(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])[0-9]{8}$/;
            var reg02 =
                /^09\d{8}$/;
            var reg03 =
                /^(008529|008526|008525)\d{7}$/;
            var reg04 =
                /^(0049)\d{11}$/;
            var reg05 =
                /^(0081)\d{10}$/;
            if (reg01.test(this.ruleForm.phone) || reg02.test(this.ruleForm.phone) || reg03.test(this.ruleForm.phone) || reg04.test(this.ruleForm.phone) || reg05.test(this.ruleForm.phone)) {
                callback();
            } else {
                callback(new Error('手机号码长度不正确'));
            }
            ;
        };

        var email_over = (rule, value, callback) => {
            var reg = new RegExp(
                "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"); //正则表达式
            var obj = this.ruleForm.email;
            if (obj === "") { //输入不能为空
                callback(new Error('输入不能为空'));
            } else if (!reg.test(obj)) { //正则验证不通过，格式不对
                callback(new Error('邮箱格式不正确'));
            } else {
                callback();
            }
        };

        var code_over = (rule, value, callback) => {
            var code = this.ruleForm.phone_code;
            if (code == '') {
                callback();
            } else if (code.length == 6) {
                postData('/admin/agent/checkCode', {
                    code: code
                }).then(res => {
                    if (res.data.status == 0) {
                        callback();
                    } else {
                        callback(new Error('验证码错误'));
                    }
                });
            } else {
                callback(new Error('验证码长度错误。'));
            }
        }
        return {
            showModal: false, //地图模态
            negativeimageUrl: require('../assets/images/idcardb.png'),
            justimageUrl: require('../assets/images/idcardf.png'),
            Contractdata: require('../assets/images/yzzzpic.png'),
            License: require('../assets/images/htzlpic.png'),
            Otherdata: require('../assets/images/htzlpic.png'),
            rank: 1,
            //				三级联动
            arr: [],
            prov: '北京',
            city: '北京',
            district: '东城区',
            cityArr: [],
            districtArr: [],
            ruleForm: {
                name: '',
                nickname: '',
                remark: '',
                contract_num: '',
                phone: '',
                email: '',
                address: '',
                lng: 0,
                lat: 0,
                group_id: '',
                acc_num: 0,
                copyright: 0,
                offline: 0,
                resource: 1,
                setdate: null,
                phone_code: '', //验证码
                rank: '', //验证码
                negativeimageUrl: '',
                justimageUrl: '',
                Contractdata: '',
                License: '',
                Otherdata: '',
                MultipleWorks: 0, // 是否开启多作品
                Mulacc_num: null, // 多作品终端数
            },
            ruleFormNew: '',
            updata_key: [],
            group_list: [],
            rules: {
                contract_num: [{
                    required: true,
                    message: '请输入合同编号',
                    trigger: 'change'
                }],
                nickname: [{
                    required: true,
                    message: '请输入公司名称',
                    trigger: 'change'
                }, {
                    min: 1,
                    max: 30,
                    message: '长度在 1到 30 个字符',
                    trigger: 'change'
                }],
                name: [{
                    required: true,
                    message: '请输入合同商姓名',
                    trigger: 'change'
                }, {
                    min: 1,
                    max: 15,
                    message: '长度在 1到 15 个字符',
                    trigger: 'change'
                }],
                phone: [{
                    required: true,
                    validator: phone_over,
                    trigger: 'change'
                }],
                email: [{
                    required: true,
                    validator: email_over,
                    trigger: 'change'
                }, {
                    type: 'email',
                    message: '请输入正确的邮箱地址',
                    trigger: 'change'
                }],
                address: [{
                    required: true,
                    message: '请输入公司地址',
                    trigger: 'change'
                }],
                author: [{
                    required: true,
                    message: '请输入作者昵称',
                    trigger: 'change'
                }],
                group_id: [{
                    required: true,
                    message: '请选择合作版本',
                }],
                setdate: [{
                    required: true,
                    validator: isData,
                    trigger: 'change'
                }],
                phone_code: [{
                    required: true,
                    validator: code_over,
                    trigger: 'change'
                }],
                card_over: [{
                    required: true,
                    validator: card_over,
                }],
                Contractdata: [{
                    required: true,
                    message: '请上传合同资料',
                }],
            },
            canTakeCode: false, //是否允许再次获取验证码
            code_time: 60, //验证码间隔
        };
    },
    mounted() {
        var _this = this;
        //获取城市信息
        this.arr = getArr();
        for (var i in this.arr) {
            var obj = this.arr[i];
            if (obj.name == this.prov) {
                this.cityArr = obj.sub;
                break;
            }
        }
        this.city = this.cityArr[1].name;
        for (var i in this.cityArr) {
            var obj = this.cityArr[i];
            if (obj.name == this.city) {
                this.districtArr = obj.sub;
                break;
            }
        }
        if (this.districtArr && this.districtArr.length > 0 && this.districtArr[1].name) {
            this.district = this.districtArr[1].name;
        } else {
            this.district = '';
        }
        //获取合作版本信息
        this.getList();
        //确认是否处于编辑状态
        if (typeof this.$router.currentRoute.query.id != 'undefined') {
            postData('/admin/agent/detail', {
                id: this.$router.currentRoute.query.id
            }).then(res => {
                _this.$set(_this.ruleForm, 'nickname', res.data.data.nickname);
                _this.$set(_this.ruleForm, 'contract_num', res.data.data.contract_num);
                _this.$set(_this.ruleForm, 'name', res.data.data.name);
                _this.$set(_this.ruleForm, 'author', res.data.data.author);
                _this.$set(_this.ruleForm, 'address', res.data.data.address);
                _this.$set(_this.ruleForm, 'group_id', res.data.data.group_id);
                _this.$set(_this.ruleForm, 'phone', res.data.data.phone);
                _this.$set(_this.ruleForm, 'email', res.data.data.email);
                _this.$set(_this.ruleForm, 'remark', res.data.data.remark);
                _this.$set(_this.ruleForm, 'lng', res.data.data.lng);
                _this.$set(_this.ruleForm, 'lat', res.data.data.lat);
                _this.rank = res.data.data.rank;
                _this.prov = res.data.data.a_province;
                _this.city = res.data.data.a_city;
                _this.district = res.data.data.a_county;
                var rank = JSON.parse(JSON.stringify({
                    rank: _this.rank,
                    prov: _this.prov,
                    city: _this.city,
                    district: _this.district,
                }));
                _this.$set(_this.ruleForm, 'rank', rank);
                _this.$set(_this.ruleForm, 'acc_num', res.data.data.acc_num);
                var is_work_set = res.data.data.is_work;
                if (is_work_set == -1 || is_work_set < 0) {
                    _this.ruleForm.MultipleWorks = 0;
                    _this.ruleForm.Mulacc_num = 0;
                } else {
                    _this.ruleForm.MultipleWorks = 1;
                    _this.$set(_this.ruleForm, 'Mulacc_num', is_work_set);
                }

                if (res.data.data.id_pic != null && res.data.data.id_pic.length == 2) {
                    _this.$set(_this.ruleForm, 'negativeimageUrl', res.data.data.id_pic[0]);
                    _this.$set(_this.ruleForm, 'justimageUrl', res.data.data.id_pic[1]);
                    _this.negativeimageUrl = res.data.data.id_pic[0];
                    _this.justimageUrl = res.data.data.id_pic[1];
                }
                if (res.data.data.contract_pic != null && res.data.data.contract_pic[0] != '') {
                    // _this.$set(_this.ruleForm,'Contractdata',res.data.data.contract_pic[0]);
                    _this.ruleForm.Contractdata = res.data.data.contract_pic;
                }
                if (res.data.data.bl_pic != null && res.data.data.bl_pic[0] != '') {
                    // _this.$set(_this.ruleForm,'License',res.data.data.bl_pic[0]);
                    _this.ruleForm.License = res.data.data.bl_pic;
                }
                if (res.data.data.other_pic != null && res.data.data.other_pic[0] != '') {
                    // _this.$set(_this.ruleForm,'Otherdata',res.data.data.other_pic[0]);
                    _this.ruleForm.Otherdata = res.data.data.other_pic;
                }
                _this.$set(_this.ruleForm, 'setdate', [new Date(res.data.data.start_time * 1000), new Date(
                    res.data.data.end_time * 1000)]);
                _this.$set(_this.ruleForm, 'copyright', res.data.data.copyright);
                _this.$set(_this.ruleForm, 'resource', res.data.data.data_copyright);
                _this.$set(_this.ruleForm, 'offline', res.data.data.offline ? 1 : 0);
                _this.ruleForm.setdate = [res.data.data.start_time, res.data.data.end_time]
                _this.ruleFormNew = JSON.parse(JSON.stringify(_this.ruleForm));
            });
        }
    },
    methods: {
        //获取数据
        getList: function (num) {
            if (typeof num != 'undefined' && num != null) {
                this.page = num;
            }
            var param = {
                page: this.page,
                limit: this.pagesize,
                keyword: this.tableDataName,
            };
            getData('/admin/agentGroup/index', param).then(res => {
                this.group_list = res.data.data;
            });
        },
        //文件上传
        uploadSectionFile_card_1: function (data) {
            // qiniuPost(data, this, 'justimageUrl');
            let that = this
            OSSuploadPost({
                res: data, callback: function (file_url) {
                    that['justimageUrl'] = file_url;
                    if (typeof that.ruleForm != 'undefined') {
                        that.ruleForm['justimageUrl'] = file_url;
                    }
                    that.$loading().close();
                }
            });
        },
        uploadSectionFile_card_2: function (data) {
            let that = this
            // qiniuPost(data, this, 'negativeimageUrl');
            OSSuploadPost({
                res: data, callback: function (file_url) {
                    that['negativeimageUrl'] = file_url;
                    if (typeof that.ruleForm != 'undefined') {
                        that.ruleForm['negativeimageUrl'] = file_url;
                    }
                    that.$loading().close();
                }
            });
        },
        LicensehandleAvatarSuccess: function (data) {
            // qiniuPost(data,this,'License');
            var _this = this;
            if (typeof _this.ruleForm.License != 'object') {
                _this.ruleForm.License = [];
            }
            OSSuploadPost({
                res: data, callback: function (file_url) {
                    _this.ruleForm.License.push(file_url);
                    _this.$loading().close();
                }
            });
        },
        ContractdatahandleAvatarSuccess: function (data) {
            var _this = this;
            if (typeof _this.ruleForm.Contractdata != 'object') {
                _this.ruleForm.Contractdata = [];
            }
            OSSuploadPost({
                res: data, callback: function (file_url) {
                    _this.ruleForm.Contractdata.push(file_url);
                    _this.$loading().close();
                }
            });
        },
        OtherdatahandleAvatarSuccess: function (data) {
            var _this = this;
            if (typeof _this.ruleForm.Otherdata != 'object') {
                _this.ruleForm.Otherdata = [];
            }
            OSSuploadPost({
                res: data, callback: function (file_url) {
                    _this.ruleForm.Otherdata.push(file_url);
                    _this.$loading().close();
                }
            });
        },
        // 删除图片
        delContractdata(index) {
            this.$confirm("确认删除该图片?", "信息", {
                cancelButtonText: "取消",
                confirmButtonText: "确定",
                type: "warning",
            }).then(() => {
                this.ruleForm.Contractdata.splice(index, 1);
                this.$message({
                    type: "success",
                    message: "删除成功!",
                });
            })
        },
        delLicense(index) {
            this.$confirm("确认删除该图片?", "信息", {
                cancelButtonText: "取消",
                confirmButtonText: "确定",
                type: "warning",
            }).then(() => {
                this.ruleForm.License.splice(index, 1);
                this.$message({
                    type: "success",
                    message: "删除成功!",
                });
            })
        },
        delOtherdata(index) {
            this.$confirm("确认删除该图片?", "信息", {
                cancelButtonText: "取消",
                confirmButtonText: "确定",
                type: "warning",
            }).then(() => {
                this.ruleForm.Otherdata.splice(index, 1);
                this.$message({
                    type: "success",
                    message: "删除成功!",
                });
            })
        },
        //获取验证码
        takePhoneCode: function () {
            var _this = this;
            if (this.updata_key.length == 0) {
                this.$message({
                    type: 'error',
                    message: '未修改信息'
                });
                return false;
            }
            _this.ruleForm.phone_code = '';
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    //拼接信息
                    var res_text = '';
                    if (_this.rank == 1) {
                        res_text = '全国终端商:使用周期为' + _this.ruleForm.setdate[0] +
                            //   _this.ruleForm.setdate[0].getFullYear()+'-'+(_this.ruleForm.setdate[0].getMonth()+1)+'-'+_this.ruleForm.setdate[0].getDate()+
                            '至' + _this.ruleForm.setdate[1]
                        //   _this.ruleForm.setdate[1].getFullYear()+'-'+(_this.ruleForm.setdate[1].getMonth()+1)+'-'+_this.ruleForm.setdate[1].getDate();
                    } else if (_this.rank == 2) {
                        res_text = '省级合作:合作商地址为' + _this.prov;
                    } else {
                        res_text = '区域终端商:合作商地址为' + _this.prov + '-' + _this.city + '-' + _this.district;
                    }
                    var updata_info = {};
                    for (var i = 0; i < _this.updata_key.length; i++) {
                        updata_info[_this.updata_key[i]] = _this.ruleForm[_this.updata_key[i]];
                    }
                    //表单完成验证，开始提交
                    var param = {
                        name: _this.ruleForm.name,
                        nickname: _this.ruleForm.nickname,
                        phone: _this.ruleForm.phone,
                        html: res_text,
                        is_updated: 1,
                        updata_key: updata_info
                    }
                    _this.canTakeCode = true;
                    postData('/admin/agent/sendCode', param).then(res => {
                        var interval;
                        interval = setInterval(function () {
                            if (_this.code_time != 0) {
                                _this.code_time--;
                            } else {
                                clearInterval(interval);
                                _this.code_time = 60;
                                _this.canTakeCode = false;
                            }
                        }, 1000);
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: '部分信息填写不正确，请检查后重试!'
                    });
                    return false;
                }
            });
        },

        submitForm: function (formName) {
            var _this = this;
            //检查身份证信息
            if (this.ruleForm.negativeimageUrl == '' || this.ruleForm.justimageUrl == '') {
                this.$message({
                    type: 'error',
                    message: '身份证照片未完整上传，请上传后重试!'
                });
                return false;
            }
            if (_this.ruleForm.MultipleWorks == 1 && _this.ruleForm.Mulacc_num == null) {
                this.$message({
                    type: 'error',
                    message: '请输入多作品终端数！'
                });
                return false;
            }
            if (_this.ruleForm.MultipleWorks == 1 && _this.ruleForm.acc_num != 0 && (_this.ruleForm.Mulacc_num > _this.ruleForm.acc_num)) {
                this.$message({
                    type: 'error',
                    message: '多作品终端数不能大于终端总数！'
                });
                return false;
            }
            if (_this.ruleForm.MultipleWorks == 0) {
                _this.ruleForm.Mulacc_num = -1;
            }
            //验证验证码是否输入
            if (_this.ruleForm.phone_code.length != 6) {
                this.$message({
                    type: 'error',
                    message: '请输入完整的短信验证码!'
                });
                return false;
            }
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //表单完成验证，开始提交
                    var param = {
                        id: _this.$router.currentRoute.query.id,
                        nickname: _this.ruleForm.nickname,
                        contract_num: _this.ruleForm.contract_num,
                        name: _this.ruleForm.name,
                        author: _this.ruleForm.author,
                        address: _this.ruleForm.address,
                        address_lng: _this.ruleForm.lng,
                        address_lat: _this.ruleForm.lat,
                        group_id: _this.ruleForm.group_id,
                        phone: _this.ruleForm.phone,
                        email: _this.ruleForm.email,
                        rank: _this.rank,
                        // is_one:_this.ruleForm.is_one,
                        a_province: _this.prov,
                        a_city: _this.city,
                        a_county: _this.district,
                        acc_num: _this.ruleForm.acc_num,
                        remark: _this.ruleForm.remark,
                        id_pic: [_this.ruleForm.negativeimageUrl, _this.ruleForm.justimageUrl],
                        contract_pic: _this.ruleForm.Contractdata,
                        bl_pic: _this.ruleForm.License,
                        other_pic: _this.ruleForm.Otherdata,
                        start_time: _this.ruleForm.setdate == null ? null : _this.ruleForm.setdate[0],
                        end_time: _this.ruleForm.setdate == null ? null : _this.ruleForm.setdate[1],
                        copyright: _this.ruleForm.copyright,
                        offline: _this.ruleForm.offline ? 1 : 0,
                        data_copyright: _this.ruleForm.resource,
                        idcard_pic: '',
                        code: _this.ruleForm.phone_code,
                        is_work: _this.ruleForm.Mulacc_num == null ? -1 : _this.ruleForm.Mulacc_num,
                    };

                    postData('/admin/agent/edit', param).then(res => {
                        if (res.data.status == 0) {
                            _this.$message({
                                type: 'success',
                                message: '提交成功！'
                            });
                            setTimeout(function () {
                                _this.$router.replace('/summary/partner')
                            }, 1500)
                        } else {
                            _this.$message({
                                type: 'error',
                                message: '提交失败！' + res.data.message
                            });
                        }
                    });

                } else {
                    this.$message({
                        type: 'error',
                        message: '部分信息填写不正确，请检查后重试!'
                    });
                    return false;
                }
            });
        },
        beforeAvatarUpIDcard: function (file) { //身份证上传前
            var _this = this;
            const isJPG = file.type === 'image/jpeg/png';
            const isLt2M = file.size / 1024 / 1024 < 5;
            if (!isLt2M) {
                this.$message.error('上传身份证图片大小不能超过 5MB!');
            } else {
                _this.$loading({
                    lock: true,
                    text: '上传中',
                });
            }
            return isLt2M;
        },
        beforeAvatarUpload: function (file) { //图片上传前
            var _this = this;
            const isJPG = file.type === 'image/jpeg/png';
            const isLt2M = file.size / 1024 / 1024 < 5;
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 5MB!');
            } else {
                _this.$loading({
                    lock: true,
                    text: '上传中',
                });
            }
            return isLt2M;
        },
        //模态框打开
        toggleModal: function () {
            this.$refs.gaode_map.lng = this.ruleForm.lng;
            this.$refs.gaode_map.lat = this.ruleForm.lat;
            this.$refs.gaode_map.searchKey = this.ruleForm.address;
            this.showModal = !this.showModal;

        },
        //关闭模态框
        closeme: function (e) {
            this.showModal = !this.showModal;
            if (e) {
                this.$set(this.ruleForm, 'address', e.text);
                this.$set(this.ruleForm, 'lng', e.lng);
                this.$set(this.ruleForm, 'lat', e.lat);
            }
        },
        updateCity: function () {
            for (var i in this.arr) {
                var obj = this.arr[i];
                if (obj.name == this.prov) {
                    this.cityArr = obj.sub;

                    for (var j in this.cityArr) {
                        if (this.cityArr[j].name == this.city) {
                            return false;
                        }
                    }
                    break;
                }
            }
            this.city = this.cityArr[1].name;
        },
        updateDistrict: function () {
            for (var i in this.cityArr) {
                var obj = this.cityArr[i];
                if (obj.name == this.city) {
                    this.districtArr = obj.sub;

                    for (var j in this.districtArr) {
                        if (this.districtArr[j].name == this.district) {
                            return false;
                        }
                    }
                    break;
                }
            }
            if (this.districtArr && this.districtArr.length > 0 && this.districtArr[1].name) {
                this.district = this.districtArr[1].name;
            } else {
                this.district = '';
            }
        },
        resetPassword() {
            if (this.ruleForm.phone_code == '') {
                this.$message.error('请先输入验证码!');
                return false;
            } else if (this.ruleForm.phone_code.length != 6) {
                this.$message.error('请输入完整的验证码!');
                return false;
            }
            var param = {
                id: this.$router.currentRoute.query.id,
                code: this.ruleForm.phone_code,
            }
            postData('/admin/agent/Resetpswd', param).then(res => {
                if (res.data.status == 0) {
                    this.$message.success(res.data.message);
                } else {
                    this.$message.error(res.data.message);
                }
            });
        },
        updataKey: function (val) {
            var _this = this;
            var ruleFormNew = this.ruleFormNew;
            if (ruleFormNew) {
                Object.keys(val).forEach((key) => {
                    if (key === "phone_code") {
                        return;
                    }
                    let result = _this.updata_key.indexOf(key);//3
                    if (typeof val[key] != 'object') {

                        if (val[key] != ruleFormNew[key]) {
                            if (result == -1) {
                                _this.updata_key.push(key);
                            }
                        } else {
                            if (result > -1) {
                                _this.updata_key.splice(result, 1);
                            }
                        }
                    } else {

                        var l = Object.keys(val[key]).length;
                        var n_l = Object.keys(ruleFormNew[key]).length;
                        //获取a和b的属性长度
                        if (l != n_l) {
                            if (result == -1) {
                                _this.updata_key.push(key);
                            }
                        } else {
                            var is_updata = 1;
                            if (key == 'rank') {
                                switch (val.rank.rank) {
                                    case 3:
                                        if (val.rank.rank != ruleFormNew.rank.rank || val.rank.prov != ruleFormNew.rank.prov) {
                                            if (result == -1) {
                                                _this.updata_key.push(key);
                                                is_updata = 0;
                                            }
                                        }
                                        break;
                                    case 1:
                                        if (val.rank.rank != ruleFormNew.rank.rank) {
                                            if (result == -1) {
                                                _this.updata_key.push(key);
                                                is_updata = 0;
                                            }
                                        }
                                        break;
                                    case 4:
                                        if (val.rank.rank != ruleFormNew.rank.rank || val.rank.prov != ruleFormNew.rank.prov || val.rank.city != ruleFormNew.rank.city || val.rank.district != ruleFormNew.rank.district) {
                                            if (result == -1) {
                                                _this.updata_key.push(key);
                                                is_updata = 0;
                                            }
                                        }
                                        break;
                                }
                            } else {
                                Object.keys(val[key]).forEach((i) => {
                                    if (val[key][i] != ruleFormNew[key][i]) {
                                        if (result == -1) {
                                            _this.updata_key.push(key);
                                        }
                                        is_updata = 0;
                                        return;
                                    }
                                })

                            }

                            if (is_updata == 1) {
                                if (result > -1) {
                                    _this.updata_key.splice(result, 1);
                                }
                            }
                        }
                    }
                })
            }

        }
    },
    watch: {
        prov: function (val) {
            this.ruleForm.rank.prov = val;
            this.updateCity();
            this.updateDistrict();
        },
        city: function (val) {
            this.ruleForm.rank.city = val;
            this.updateDistrict();
        },
        district: function (val) {
            this.ruleForm.rank.district = val;
        },
        rank: function (val) {
            this.ruleForm.rank.rank = val;
        },
        ruleForm: {
            handler(val, oldVal) {
                this.updataKey(val)
            },
            deep: true
        }
        // 'ruleForm.phone':function(data){
        //   if(data.length == 11){
        //     //验证手机号是否注册
        //     postData('/admin/agent/checkPhone',{phone:data}).then(res=>{
        //       console.log(res)
        //       if(res.data.status==0){
        //         console.log("当前手机号码可用")
        //       }else{
        //         console.log("当前手机号码不可用")
        //       }
        //     });
        //   }
        // },
    },
    components: {
        Modal
    },
}
</script>

<style>
.partner_addupdate {
    width: 100%;
}

.partner_addupdate .el-input__icon {
    height: auto !important;
}

.partner_addupdate .el-form-item__label {
    height: 30px;
    line-height: 30px;
}

.partner_addupdate .el-input {
    width: 320px !important;
}

.partner_addupdate .el-input input {
    width: 100%;
    /* width: 200px; */
}

/*存在bug，暂时没有解决办法*/
.el-select-dropdown.el-popper {
    /* width: 200px !important; */
    /* min-width: 0 !important; */

}

.partner_addupdate .el-input input::-webkit-input-placeholder {
    color: #81868c;
}

.partner_addupdate .el-input input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #81868c;
}

.partner_addupdate .el-input input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #81868c;
}

.partner_addupdate .el-input input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #81868c;
}

.partner_addupdate .el-form-item__error {
    /* display: none; */
    color: #F56C6C;
    font-size: 12px;
    line-height: 15px;
    padding-top: 4px;
    position: absolute;
    top: 5px;
    left: 380px;
}

.partner_addupdate .Address {
    width: 30px;
    height: 20px;
    padding-left: 5px;
}

/*上传身份证*/

.partner_addupdate .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    margin-right: 10px;
}

.partner_addupdate .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.partner_addupdate .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.partner_addupdate .avatar {
    width: 300px;
    height: 190px;
    display: block;
}

.partner_addupdate .partner_addupdate .el-form-item__content .just {
    width: 75%;
    border: 1px solid #d2d2d2;
    padding: 20px 20px;
}

.partner_addupdate .el-form-item__content .just .just_div {
    display: flex;
    margin: 10px;
}

.partner_addupdate .el-form-item {
    margin-bottom: 10px;
}

.partner_addupdate .el-form-item__content .just p {
    margin-top: 8px 0 0 10px;
    color: #aeaeae;
    font-size: 14px;
    height: 20px;
    line-height: 20px;
}

.partner_addupdate .el-form-item__content .just p i {
    color: #ff7800;
    font-style: normal;
}

/*联动*/

.partner_addupdate #example {
    display: flex;
}

.partner_addupdate #example select {
    width: 118px;
    height: 30px;
    cursor: pointer;
    border: 1px solid rgb(229, 229, 229);
    border-radius: 3px;
    background-color: rgb(255, 255, 255);
    color: #202020;
    box-shadow: inset 0px 3px 7px 0px rgba(0, 0, 0, 0.07);
    -webkit-box-shadow: inset 0px 3px 7px 0px rgba(0, 0, 0, 0.07);
    margin-right: 20px;
}

.partner_addupdate .el-date-editor .el-range-separator {
    padding: 0 5px;
    line-height: 24px;
    width: 5%;
    color: #303133;
}

.partner_addupdate .date {
}

.partner_addupdate .terminalsnum {
    display: flex;
    align-items: center;
}

.partner_addupdate .terminalsnum p {
    color: #000;
    text-indent: 10px;
}

.partner_addupdate .copyright {
    display: flex;
    margin-bottom: 20px;
}

.partner_addupdate .submit {
    display: flex;
    margin-bottom: 20px;
    margin-top: 20px;
}

.partner_addupdate .submit .el-button--primary {
    display: block;
    line-height: 30px;
    height: 30px;
    white-space: nowrap;
    cursor: pointer;
    background: #fe9000;
    border: 1px solid #DCDFE6;
    color: #fff;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    padding: 0px 30px;
    margin-right: 20px;
    font-size: 14px;
    border-radius: 4px;
}

.partner_addupdate .submit .el-button--success {
    background-color: #409EFF;
    border-color: #409EFF;
}

.partner_addupdate .form_title {
    font-weight: bold;
    font-size: 14px;
    margin: 0 15px 10px;
}

.partner_addupdate .form_title img {
    height: 13px;
    margin-right: 8px;
}

.partner_addupdate .el-form-item__content .el-radio-group {
    margin-top: 5px;
}

.partner_addupdate .phone_code {
    width: 320px;
}

.partner_addupdate .phone_code .el-input {
    width: 150px !important;
    float: left;
}

.partner_addupdate .phone_code button {
    float: left;
}

.partner_addupdate .el-popper[x-placement^=bottom] {
    margin-top: 40px;
}

.partner_addupdate .el-form-item__content .el-radio-group {
    line-height: 19px;
}
</style>



// WEBPACK FOOTER //
// src/summary/partner/update_data.vue